export const enum EEquipmentMode {
  DEFAULT = 'DEFAULT',
  ADD = 'ADD'
}
